module.exports = __webpack_public_path__ + "img/not-authorized.82b89f4e.png";